// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"spinner_spinnerContainer__Gk48J","spinner":"spinner_spinner__LJdAT"};